import React, { useState } from 'react';
import { Box, Pagination, Typography } from '@mui/material';
import { useAuth } from '../../hooks/useAuth';
import PatientsList from '../components/patients/PatientsList';
import PatientFilterPanel, { FilterFields } from '../components/patients/PatientFilterPanel';
import { usePatientsQuery } from '../../queries/usePatientsQuery';
import { useClientStore } from '../../stores/clientStore';
import ListSizeSelector from '../components/elements/ListSizeSelector';

const patientSortKeys:[string,number][] = [
    ['Name',1],
    ["zip",1]
]

const PAGE_ZERO = 1;

const PatientsPageV3: React.FC = () => {
  const auth = useAuth();
  const { client, clientId } = useClientStore();
  const [filterParams, setFilterParams] = useState<Partial<Record<'page' | 'sort' | FilterFields, string>>>({sort:'Name', status:'Active'});
  const [page, setPage] = useState<number>(PAGE_ZERO);
  const [pageSize, setPageSize] = useState<number>(10);

  const filterParamsAsStrings:{
    filters:[string, string][],
    sort:[string, number][]
  } = React.useMemo(() => {
    const filterEntries = Object.entries(filterParams);
    const defaultSort = patientSortKeys[0];
    const sortKey = filterEntries.filter(f => f[0] == 'sort')?.at(0)?.[0] || defaultSort[0];
    
    return {
      filters:filterEntries.filter(f => f[0] != 'sort' && f[0] != 'page' && f[1] != ''),
      sort:[patientSortKeys.find(f => f[0] == sortKey) || defaultSort]
    }
  },[filterParams]);

  const { data:patientData, isLoading:isPatientsLoading, isFetching:isPatientFetching, error:patientError } 
    = usePatientsQuery(clientId, filterParamsAsStrings.filters, pageSize, page, filterParamsAsStrings.sort)
  const patientList = patientData?.patients || [];
  const assignmableUsers = React.useMemo(() => { return [...(client?.userAccess?.map(u => u.name) || []), 'Uknown']; }, [client]);
  const patientCount = patientData?.numPats || 0;


  return (
    <Box sx={{ p: 1, height:'84%' }}>
      {
        client && <PatientFilterPanel client={client} plans={[]}
          syncing={isPatientFetching}
          onChange={(data) => {
            setPage(PAGE_ZERO);
            setFilterParams(data);
          }}
          searchParams={filterParams}
          userAssignmentFilters={assignmableUsers}
        />
      }
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 1 }}>
        <Typography>{`${patientCount} Patients`}</Typography>
        <Pagination count={ Math.floor((patientCount/pageSize)) + 1} page={page}
          onChange={(_, p) => { setPage(p); }}
        />
        <ListSizeSelector values={[10,15,20,25,30]} onChange={setPageSize}/>
      </Box>
      <PatientsList patients={patientList} loading={isPatientFetching}/>
    </Box>
  );
};

export default PatientsPageV3;